import { initializeFaro } from '@grafana/faro-web-sdk';

import {
  APP_VERSION,
  ENVIRONMENT,
  FARO_API_KEY,
  FARO_URL_BASE,
  IS_FARO_ENABLED,
} from '../config';

import { debug } from './debug';

let faroInstance: ReturnType<typeof initializeFaro> | null = null;

export const initializeFaroAnalytics = () => {
  if (!IS_FARO_ENABLED || faroInstance) {
    return faroInstance;
  }

  try {
    faroInstance = initializeFaro({
      url: `${FARO_URL_BASE}/collect`,
      apiKey: FARO_API_KEY,
      app: {
        name: 'diagnocat-client-core',
        version: APP_VERSION,
        environment: ENVIRONMENT,
      },
    });

    return faroInstance;
  } catch (error) {
    debug('Failed to initialize Faro Web SDK:', error);
    return null;
  }
};

export const getFaroInstance = () => faroInstance;

export const setFaroUser = (userId: string) => {
  faroInstance?.api.setUser({ id: userId });
};

export const resetFaroUser = () => {
  faroInstance?.api.resetUser();
};

export const setFaroView = (viewName: string) => {
  faroInstance?.api.setView({ name: viewName });
};

export const pushFaroEvent = (
  name: string,
  attributes?: Record<string, string>,
) => {
  faroInstance?.api.pushEvent(name, attributes);
};
